import styled from "styled-components";

export const SelectLanguageStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  & .ant-select {
    width: 100%;
    &-selector {
      width: 80px !important;
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
      background-color: #3a3a3a !important;
      color: ${(props) => props.theme.text.white} !important;
      border-radius: 10px;
    }
    &-selection-item {
      display: flex;
      align-items: center;
      color: ${(props) => props.theme.text.white} !important;
    }
    &-arrow {
      color: #ccc;
    }
    &-selection-placeholder {
      display: flex;
      align-items: center;
      color: ${(props) => props.theme.text.white} !important;
      opacity: 0.5;
    }
  }
`;
